import React from "react";
import { QueryClientProvider, HydrationBoundary, DehydratedState } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { getQueryClient } from "./queryClient";

interface QueryProviderProps {
    children: React.ReactNode;
    /**
     * État de cache sérialisé provenant du serveur. Non utilisé tant qu'on est
     * en SPA pure, mais la boundary est déjà câblée — le jour où on passe à
     * Next.js / Node, il suffira de faire remonter le `dehydratedState`
     * généré côté serveur jusqu'ici.
     */
    dehydratedState?: DehydratedState;
}

/**
 * Wrapper unique à poser au plus haut niveau de l'app.
 * Fournit le QueryClient et la boundary d'hydration.
 */
const QueryProvider: React.FC<QueryProviderProps> = ({ children, dehydratedState }) => {
    const queryClient = getQueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
            {process.env.NODE_ENV === "development" && (
                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
            )}
        </QueryClientProvider>
    );
};

export default QueryProvider;
